import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import {
  IonButton,
  IonCheckbox,
  IonCol,
  IonTextarea,
  IonIcon,
  IonGrid,
  IonItem,
  IonLabel,
  IonModal,
  IonRow,
  IonSearchbar,
  IonAlert,
} from "@ionic/react";

import { close } from "ionicons/icons";
import { CONSTANTS, ERROR } from "../../../constants";
import _ from "lodash";
import { utilService } from "../../../services/utilService";
import "./HomeGroupSms.scss";
import { useToast } from "@agney/ir-toast";
import { SendGroupSmsResp } from "../GroupSms/GroupSms.model";
import { rolePermissionsService } from "../../../services/rolePermissions.service";
import { groupSmsService } from "../GroupSms/GroupSms.service";
import GroupSmsAccordion from "./GroupSmsAccordion/GroupSmsAccordion";

interface sendSmsProps {
  showModal: boolean;
  onCancel: () => void;
  onOk: () => void;
  doctorListDataFromParent: any;
  accordionList: any;
}

const HomeGroupSms: React.FC<sendSmsProps> = (props) => {
  const { t } = useTranslation("home");
  const [searchText, setSearchText] = useState("");
  const [comment, setComment] = useState<string>("");
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [sendSmsSubmitData, setSendSmsSubmitData] = useState<any>(Object);
  const [isSelectAll, setSelectAll] = useState(false);
  const [isCheckedAll, setCheckedAll] = useState(false);
  const [selectedDoctorCard, setSelectedDoctorDetails]: any = useState([]);
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [currentErrorMessage, setCurrentErrorMessage]: any = useState();
  const [isInputEmpty, setIsInputEmpty] = useState(true);
  const [selectedAllStatus, setSelectedAllStatus] = useState(false);
  const [disableSendButton, setDisableSendButton] = useState(true);
  const [isSmallScreen, setIsSmallScreen]: any = useState(false);
  const [doctorData, setDoctorData]: any = useState([]);
  const [accordionListFromParent, setAccordionListFromParent]: any = useState({
    own: {},
    added: {},
  });

  const Toast = useToast();

  useEffect(() => {
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
    checkIfSmallScreen();
  }, []);

  useEffect(() => {
    setDoctorData(props.doctorListDataFromParent);
  }, [props.doctorListDataFromParent]);

  useEffect(() => {
    getNonEmptyAccordionList();
  }, [props.accordionList]);

  const deleteEmptyObject = (listObject: any) => {
    for (var listObjectItem in listObject) {
      if (listObject[listObjectItem].data.length === 0) {
        delete listObject[listObjectItem];
      }
    }
    return listObject;
  };

  const getNonEmptyAccordionList = () => {
    if (!_.isEmpty(props.accordionList)) {
      const ownListTemp = _.cloneDeep(props.accordionList.own);
      const addedListTemp = _.cloneDeep(props.accordionList.added);
      var ownList = deleteEmptyObject(ownListTemp);
      var addedList = deleteEmptyObject(addedListTemp);
      const accordionList = {
        own: ownList ? ownList : {},
        added: addedList ? addedList : {},
      };
      setAccordionListFromParent(_.cloneDeep(accordionList));
    }
  };

  useEffect(() => {
    disableGroupSmsButton();
  }, [isInputEmpty, selectedDoctorCard]);

  useEffect(() => {
    if (selectedAllStatus === true) {
      setSelectAll(true);
    }
  }, [selectedAllStatus]);

  async function sendGroupSms() {
    const params: any = getGroupSmsApiParams();

    const respSendSmsResult: SendGroupSmsResp =
      await groupSmsService.sendGroupSms(params);
    if (respSendSmsResult.isSuccess) {
    } else {
      console.log("error");
      groupSmsService.handleErrorResponse();
    }
    setSendSmsSubmitData(respSendSmsResult);
    showApiResponse(respSendSmsResult);
  }

  const getGroupSmsApiParams = () => {
    return {
      message_sms: comment,
      reg_code: utilService.getNetwork(),
      time: utilService.getCurrentDateAndTime(),
      users:[...new Set(getSelectedGuid())],
      send_to_all:true,
      is_quoted_reply:false,
      quoted_message_id:"",
      action:"1",
      is_group_sms:true
    };
  };

  const getSelectedGuid = () => {
    const selectedIds: any = [];
    selectedDoctorCard.map((item: any) => {
      selectedIds.push(item.guid);
    });
    return selectedIds;
  };

  const selectAll = (event: any) => {
    setSelectAll(event.detail.checked);
  };

  useEffect(() => {
    if (!isSelectAll) {
      setDisableSendButton(true);
    }
    setCheckedAll(isSelectAll);
  }, [isSelectAll]);

  const getAllStatus = (dataFromChild: any) => {
    if (dataFromChild) {
      setSelectAll(dataFromChild);
      setCheckedAll(true);
    } else {
      setSelectAll(dataFromChild);
      setCheckedAll(false);
    }
  };

  const getSelectedCard = (selectedCard: any) => {
    if(selectedCard?.length>1){
      let tempStore = selectedDoctorCard
      selectedCard?.forEach((doctor:any) => {
        if(tempStore?.find((selectedDr:any)=>selectedDr?.guid===doctor?.guid)){
          tempStore=tempStore?.filter((selectedDr:any)=>selectedDr?.guid!==doctor?.guid)
        }else{
          tempStore=[...tempStore,doctor]
        }
      });
      setSelectedDoctorDetails(tempStore)
      
    }else{
      if(selectedDoctorCard?.find((user:any)=>user?.guid===selectedCard?.guid&&selectedCard?.isSelected)){
        setSelectedDoctorDetails(selectedDoctorCard?.filter((user:any)=>user?.guid!==selectedCard?.guid))
      }else{
        setSelectedDoctorDetails([...selectedDoctorCard,selectedCard])
      }
    }
  };

  const disableGroupSmsButton = () => {
    if (isInputEmpty || !selectedDoctorCard.length) {
      setDisableSendButton(true);
    } else {
      setDisableSendButton(false);
    }
  };

  const showApiResponse = (sendSmsData: any) => {
    if (sendSmsData.status !== 200) {
      setCurrentErrorMessage(ERROR.sendSms.SMS_SENDING_FAILED);
      setIsShowAlert(true);
    } else if (sendSmsData.status === 200) {
      Toast.success(CONSTANTS.MESSAGES.GROUP_SMS_SUCCESS);
    }
  };

  const setMessageOnSendButtonClick = () => {
    sendGroupSms();
  };

  const checkIfSmallScreen = () => {
    if (utilService.getScreenSize() === "small") {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  };

  const checkIfInputEmpty = () => {
    const isWhitespace = utilService.checkIfInputEmpty("groupSmsText");
    setIsInputEmpty(isWhitespace);
    if (isSelectAll && !isWhitespace) {
      setDisableSendButton(false);
    }
  };

  return (
    <div>
      <IonAlert
        isOpen={isShowAlert}
        onDidDismiss={() => setIsShowAlert(false)}
        cssClass="sms-alert"
        message={currentErrorMessage}
        buttons={[
          {
            text: t("ok"),
            handler: () => {
              setIsShowAlert(false);
            },
          },
        ]}
      />
      <IonModal
        isOpen={props.showModal}
        backdropDismiss={false}
        className="home-group-sms-modal"
      >
        <div className="group-sms-modal-container">
          <div
            className={`close-modal-icon ${
              isSmallScreen && "close-modal-icon-small-screen"
            }`}
            onClick={() => {
              props.onCancel();
              setComment("");
              setIsInputEmpty(true);
              setSelectAll(false);
              setSearchText("");
            }}
          >
            <IonIcon icon={close} />
          </div>

          <div
            className={`group-sms-content ${
              isSmallScreen && "group-sms-content-small-screen"
            }`}
          >
            <div className="group-sms-header">{t("groupSmsHeader")}</div>
            <div className="searchbar-container">
              <div className="select-all-button">
                <IonItem lines="none">
                  <IonCheckbox
                    className="check-box"
                    onIonChange={(event) => selectAll(event)}
                    checked={isSelectAll}
                  ></IonCheckbox>
                  <IonLabel>{t("all")}</IonLabel>
                </IonItem>
              </div>
              <div className="searchbar-containar-item">
                <IonSearchbar
                  value={searchText}
                  onIonChange={(e) => setSearchText(e.detail.value!)}
                  placeholder={t("search")}
                  type="search"
                  autocomplete="off"
                  autoCorrect="off"
                  className="searchbar"
                ></IonSearchbar>
              </div>
            </div>

            <div className="doctor-card-list-container">
              <IonGrid className="scrollbar">
                <IonRow>
                  <IonCol>
                    <GroupSmsAccordion
                      isCheckedAll={isCheckedAll}
                      getAllStatus={getAllStatus}
                      accordionList={accordionListFromParent}
                      isSelectAll={isSelectAll}
                      searchText={searchText}
                      getSelectedCard={getSelectedCard}
                    />
                  </IonCol>
                </IonRow>
              </IonGrid>
            </div>

            <div className="comment-box">
              <IonTextarea
                className="textarea-div"
                value={comment}
                maxlength={250}
                placeholder={t("groupSmsMessagePlaceholder")}
                id="groupSmsText"
                onIonChange={(e) => {
                  checkIfInputEmpty();
                  setComment(e.detail.value!);
                }}
              ></IonTextarea>
            </div>

            <div className="group-sms-button-container">
              <div className="cancel-button-div">
                <IonButton
                  color="medium"
                  className="button secondary-btn  btn-curved"
                  onClick={() => {
                    props.onCancel();
                    setComment("");
                    setIsInputEmpty(true);
                    setSelectAll(false);
                    setSearchText("");
                  }}
                >
                  {t("cancel")}
                </IonButton>
              </div>
              <div className="send-button-div">
                <IonButton
                  className="submit-btn button primary-btn btn-curved"
                  disabled={disableSendButton}
                  onClick={() => {
                    setMessageOnSendButtonClick();
                    setComment("");
                    props.onCancel();
                    setIsInputEmpty(true);
                    setSelectAll(false);
                    setSearchText("");
                  }}
                >
                  {t("send")}
                </IonButton>
              </div>
            </div>
          </div>
        </div>
      </IonModal>
    </div>
  );
};

export default HomeGroupSms;
